export enum CaregiverCallConfirmationType {
    video = 'video',
    phone = 'phone',
}
